import React, { useState, useEffect } from 'react'
import Navbar from '../components/Navbar'
import Background from '../components/Background'
import "./styles/Services.css";
import Header from '../components/Header';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Footer from '../components/Footer';


// console.log("RAW HASH:", window.location.hash);

function Services() {
    const [fadeIn, setFadeIn] = useState(false);
    const [questions, setQuestions] = useState([]);

    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;

        if (!hash) return;

        const scrollToElement = () => {
            const element = document.querySelector(hash);
            if (element) {
                console.log("Scrolling to", hash);
                element.scrollIntoView({ behavior: 'smooth' });
            } else {
                console.log("Element not found:", hash);
            }
        };

        // Wait a bit for the DOM to render
        const timeout = setTimeout(scrollToElement, 300);
        scrollToElement();
        return () => clearTimeout(timeout);
    }, [location.hash, questions]);


    useEffect(() => {
        setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
    }, []);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const [questionsRes] = await Promise.all([
                    axios.get('https://bunny-klawz.uc.r.appspot.com/questions'),
                ]);
                setQuestions(questionsRes.data);
            } catch (error) {
                console.error("Error loading settings:", error);
            }
        };

        fetchSettings();
    }, []);

    return (
        <>
            {/* <Header /> */}

            <div className={`services-page home-page ${fadeIn ? "show" : ""}`}>
                {/* <Navbar />
            <Background />
            <div className="gradient-overlay"></div> */}
                <div className='services-container fade-in show'>
                    <div id="services" className='section section1'>
                        <div className='page-header'>
                            <h2>Services</h2>
                            <p>
                                Please click{" "}
                                <a
                                    href="https://www.instagram.com/bunnyklawz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to DM @bunnyklawz on Instagram for any questions!
                            </p>
                        </div>
                        <div className='section-header'>
                            <h2>Nail Services</h2>
                            <p>
                                All nail services will include gel nail polish.
                            </p>
                        </div>
                        <div className='section-content'>
                            <div className='column column1'>
                                <div>
                                    <div>
                                        <h3>Gel Polish Mani</h3>
                                        <p>Any Length</p>
                                    </div>

                                    <div>
                                        <h3>Hard Gel Overlay</h3>
                                        <p>Any Length</p>
                                    </div>

                                    <div>
                                        <h3>Gel-X Extensions</h3>
                                        <p>Short Length</p>
                                        <p>Medium Length</p>
                                        <p>Long Length</p>
                                        <p>Extra Long Length</p>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <h3>Base Price</h3>
                                        <p>${questions[0]?.options[0].price}</p>
                                    </div>

                                    <div>
                                        <h3>Base Price</h3>
                                        <p>${questions[0]?.options[1].price}</p>
                                    </div>

                                    <div>
                                        <h3>Base Price</h3>
                                        <p>${questions[1]?.options[0].price}</p>
                                        <p>${questions[1]?.options[1].price}</p>
                                        <p>${questions[1]?.options[2].price}</p>
                                        <p>${questions[1]?.options[3].price}</p>
                                    </div>
                                </div>

                            </div>
                            <div className='column column2'>
                                <div className='free-style'>
                                    <div>
                                        <h3>Free-Style Set</h3>
                                        <p>Any Length</p>
                                    </div>
                                    <div>
                                        <h3>Full Cost</h3>
                                        <p>${questions[0]?.options[3].price}</p>
                                    </div>
                                </div>
                                <div className='free-style-description'>
                                    <p><img src="/images/Warning.png" alt="Warning" /> You can pick color, shape and length, but designs will be completely up to the nail artists. Any special requests will void the free-style set pricing and will be charged accordingly to our pricing list. You will be guaranteed Tier 2 - Tier 3 nail designs!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="tiers" className='section section2'>
                        <div className='section-header'>
                            <h2>Add-On Services: Design</h2>
                            <p>
                                Additional cost will be added to base nail service pricing.
                            </p>
                        </div>
                        <div className='section-content'>
                            <div className='add-on'>
                                <h3>French Tips</h3>
                                <p>Add-On Cost: ${questions[2]?.options[0].price}</p>
                                <img src="/images/AddOnSample.png" alt="French Tips Nail Design Sample" />
                            </div>

                            <div className='add-on'>
                                <h3>Tier 1 - Simple</h3>
                                <p>Add-On Cost: ${questions[2]?.options[1].price}</p>
                                <img src="/images/Tier1Sample.png" alt="Simple Nail Design Sample" />
                            </div>

                            <div className='add-on'>
                                <h3>Tier 2 - Intermediate</h3>
                                <p>Add-On Cost: ${questions[2]?.options[2].price}</p>
                                <img src="/images/Tier2Sample.png" alt="Intermediate Nail Design Sample" />
                            </div>

                            <div className='add-on'>
                                <h3>Tier 3 - Advanced</h3>
                                <p>Add-On Cost: ${questions[2]?.options[3].price}</p>
                                <img src="/images/Tier3Sample.png" alt="Advanced Nail Design Sample" />
                            </div>

                            <div className='add-on'>
                                <h3>Tier 4 - Sophisticated</h3>
                                <p>Add-On Cost: ${questions[2]?.options[4].price}</p>
                                <img src="/images/Tier4Sample.png" alt="Sophisticated Nail Design Sample" />
                            </div>
                        </div>
                    </div>
                    <div id="soak-offs" className='section section3'>
                        <div className='section-header'>
                            <h2>Add-On Services: Soak-Offs</h2>
                            <p>
                                Additional cost will be added to base nail service pricing.
                            </p>
                        </div>
                        <div className='section-content'>
                            <div className='column'>
                                <h3>Soak-Off Type</h3>
                                <p>Gel Polish</p>
                                <p>GelX</p>
                                <p>Acrylic</p>
                            </div>
                            <div className='column'>
                                <h3>Add-On Cost</h3>
                                <p>${questions[3]?.options[0].price}</p>
                                <p>${questions[3]?.options[1].price}</p>
                                <p>${questions[3]?.options[2].price}</p>
                            </div>
                        </div>
                        {/* <div>
                        <p>Please note if soak-off is not requested at time of booking and is requested during appointment time, $10 late fee will be added as compensation for our other clients who will be impacted with waiting time.</p>
                    </div> */}
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default Services